function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.218 0L9.347 8.8 0 8.785l7.573 5.423L4.667 23l7.551-5.452L19.77 23l-2.905-8.792 7.573-5.423-9.348.015z"
});

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2 -2 28 28"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNC40MzciIGhlaWdodD0iMjMiIHZpZXdCb3g9Ii0yIC0yIDI4IDI4Ij4KICAgIDxwYXRoIGlkPSJpYy1zdGFyIiBkPSJNMTIuMjE4LDAsOS4zNDcsOC44LDAsOC43ODVsNy41NzMsNS40MjNMNC42NjcsMjNsNy41NTEtNS40NTJMMTkuNzcsMjNsLTIuOTA1LTguNzkyLDcuNTczLTUuNDIzTDE1LjA5LDguOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiLz4KPC9zdmc+Cg==";
export { SvgStar as ReactComponent };